import React from "react";
import "../../../pages/Surveys/style.css"
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { genericGet, getList } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";


import { FaTimes, FaEdit, FaFileExport, FaArrowRight, FaExclamationCircle, FaTimesCircle, FaCheckCircle, FaPrint, FaSearch, FaSort, FaSortUp, FaSortDown, FaFilter } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'


const DEFAULT_PER_PAGE = 100;

const ListLeaveRequests = (props) => {
  const [is_loading, setIsLoading] = useState(false);

  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const [status, setstatus] = useState(10001);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: DEFAULT_PER_PAGE,
    total: 0,
    last_page: 1,
    has_more_pages: false,
  });
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [appliedUserId, setAppliedUserId] = useState("");
  
  // Table search and pagination state
  const [tableSearch, setTableSearch] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    listUsers();
    fetch_data(1, DEFAULT_PER_PAGE, "");
    return () => { };
  }, []);

  const listUsers = async () => {
    const list = await getList(ENDPOINTS.LIST_USERS);
    setUsers(Array.isArray(list) ? list : []);
  };

  const userOptions = useMemo(
    () =>
      (users || []).map((u) => ({
        value: u.value,
        label: u.text || u.label || u.name || String(u.value),
      })),
    [users]
  );

  const fetch_data = (page = 1, perPage = DEFAULT_PER_PAGE, userId = appliedUserId) => {
    setIsLoading(true);

    let url = `${ENDPOINTS.LIST_LEAVE_REQUESTS}?page=${page}&per_page=${perPage}`;
    if (userId) {
      url += `&user_id=${encodeURIComponent(userId)}`;
    }

    genericGet(url)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            const responseData = res.data?.data || {};
            const records = Array.isArray(responseData?.records) ? responseData.records : [];
            const apiPagination = responseData?.pagination || {};
            setRowData(records);
            setPagination({
              current_page: apiPagination?.current_page || page,
              per_page: apiPagination?.per_page || perPage,
              total: apiPagination?.total || records.length,
              last_page: apiPagination?.last_page || 1,
              has_more_pages: !!apiPagination?.has_more_pages,
            });
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const handleFilter = () => {
    const userId = selectedUser?.value ? String(selectedUser.value) : "";
    setAppliedUserId(userId);
    fetch_data(1, DEFAULT_PER_PAGE, userId);
  };

  const handleClearUserFilter = () => {
    setSelectedUser(null);
    setAppliedUserId("");
    fetch_data(1, DEFAULT_PER_PAGE, "");
  };

  // Filter data based on search term - searches all columns
  const filteredData = useMemo(() => {
    let data = rowData;
    
    // Apply search filter - search across all columns
    if (tableSearch) {
      const searchLower = tableSearch.toLowerCase();
      data = data.filter(item => {
        // Search in all relevant fields
        const leaveType = item?.leave_type?.name?.toLowerCase() || "";
        const requestDate = item?.request_date?.toLowerCase() || "";
        const totalDays = String(item?.total_days || "").toLowerCase();
        const leaveReason = item?.leave_reason?.toLowerCase() || "";
        const createdByName = item?.created_by?.name?.toLowerCase() || "";
        const supervisorApprovalDate = item?.supervisor_approval_date?.toLowerCase() || "";
        const hrApprovalDate = item?.hr_approval_date?.toLowerCase() || "";
        
        return leaveType.includes(searchLower) ||
               requestDate.includes(searchLower) ||
               totalDays.includes(searchLower) ||
               leaveReason.includes(searchLower) ||
               createdByName.includes(searchLower) ||
               supervisorApprovalDate.includes(searchLower) ||
               hrApprovalDate.includes(searchLower);
      });
    }
    
    // Apply sorting
    if (sortField) {
      data = [...data].sort((a, b) => {
        let aValue, bValue;
        
        if (sortField === 'leave_type') {
          aValue = a?.leave_type?.name || "";
          bValue = b?.leave_type?.name || "";
        } else if (sortField === 'created_by') {
          aValue = a?.created_by?.name || "";
          bValue = b?.created_by?.name || "";
        } else {
          aValue = a[sortField] || "";
          bValue = b[sortField] || "";
        }
        
        // Handle null/undefined values
        if (aValue == null) aValue = "";
        if (bValue == null) bValue = "";
        
        // Convert to string for comparison
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
        
        if (sortDirection === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else {
          return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
        }
      });
    }
    
    return data;
  }, [rowData, tableSearch, sortField, sortDirection]);

  const handleTableSearch = (e) => {
    setTableSearch(e.target.value);
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > pagination.last_page || is_loading) return;
    fetch_data(page, pagination.per_page || DEFAULT_PER_PAGE, appliedUserId);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const getSupervisorApprovalStatus = (item) => {
    if (item.supervisor_approval == 10000) {
      return <><FaExclamationCircle style={{ color: "grey" }} /> &nbsp; Pending</>;
    } else if (status == 10002) {
      return <><FaTimesCircle style={{ color: "red" }} /> &nbsp; Cancelled</>;
    } else if (status == 10003) {
      return <><FaTimesCircle style={{ color: "red" }} /></>;
    } else if (status == 10001) {
      return <><FaCheckCircle style={{ color: "green" }} /> &nbsp; @ {item.supervisor_approval_date}</>;
    } else {
      return <><FaCheckCircle style={{ color: "green" }} /> &nbsp; Unknown</>;
    }
  };

  const getHrApprovalStatus = (item) => {
    if (item.hr_approval == 10000) {
      return <><FaExclamationCircle style={{ color: "grey" }} /></>;
    } else if (status == 10003) {
      return <><FaTimesCircle style={{ color: "red" }} /></>;
    } else {
      return <><FaCheckCircle style={{ color: "green" }} /> &nbsp; @ {item.hr_approval_date}</>;
    }
  };

                return (
    <div className="page-wrapper">
      
         
          <div className="">
            <div className="card-header">
              <h1>Leave Requests</h1>
            </div>
            <div className="card-body">
              {is_loading && (
                <center>
                  <PulseLoader />
                </center>
              )}

              {!is_loading && (
                <>
                  <style>{`
                    .table-dark th {
                      font-size: 0.65rem !important;
                    }
                    .table-dark th span {
                      font-size: 0.65rem !important;
                    }
                    .table-dark th div {
                      font-size: 0.65rem !important;
                    }
                  `}</style>
                  {/* Filters */}
                  <div className="mb-3" style={{ width: '95%', margin: '0 auto' }}>
                    <div className="row g-2 align-items-end">
                      <div className="col-md-5">
                        <Label className="mb-1">User</Label>
                        <Select
                          options={userOptions}
                          value={selectedUser}
                          onChange={setSelectedUser}
                          isClearable
                          isSearchable
                          placeholder="Select user..."
                          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                      </div>
                      <div className="col-md-7 d-flex gap-2">
                        <Button color="primary" onClick={handleFilter} disabled={is_loading}>
                          <FaFilter className="me-1" /> Filter
                        </Button>
                        {(selectedUser || appliedUserId) && (
                          <Button color="secondary" outline onClick={handleClearUserFilter} disabled={is_loading}>
                            Clear
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Search Bar */}
                  <div className="mb-4" style={{ width: '95%', margin: '0 auto' }}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input-group">
                          <span className="input-group-text bg-primary text-white">
                            <FaSearch />
                          </span>
                          <Input
                            type="text"
                            className="form-control form-control-lg"
                            placeholder="Search by leave type, date, reason, creator, or approval status..."
                            value={tableSearch}
                            onChange={handleTableSearch}
                            style={{ borderLeft: 'none' }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 d-flex align-items-center">
                        <div className="text-muted">
                        <small>
                          Page {pagination.current_page} of {pagination.last_page} | {pagination.total} total request{pagination.total !== 1 ? 's' : ''}
                          {tableSearch && ` | ${filteredData.length} shown on this page matching "${tableSearch}"`}
                        </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Data Table */}
                  <div className="table-responsive shadow-sm" style={{ width: '95%', margin: '0 auto', overflowX: 'auto' }}>
                    <table className="table table-striped table-hover mb-0" style={{ fontSize: '0.875rem', width: '100%', tableLayout: 'auto' }}>
                      <thead className="table-dark">
                        <tr style={{ height: '35px' }}>
                          <th style={{ width: '40px', padding: '6px', whiteSpace: 'nowrap' }}>#</th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '100px', maxWidth: '150px' }}
                            onClick={() => handleSort('leave_type')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Leave Type</span>
                              <span>
                                {sortField === 'leave_type' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '100px', maxWidth: '120px' }}
                            onClick={() => handleSort('request_date')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Request Date</span>
                              <span>
                                {sortField === 'request_date' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', width: '80px' }}
                            onClick={() => handleSort('total_days')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Days</span>
                              <span>
                                {sortField === 'total_days' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '120px', maxWidth: '200px' }}
                            onClick={() => handleSort('leave_reason')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Reason</span>
                              <span>
                                {sortField === 'leave_reason' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '100px', maxWidth: '150px' }}
                            onClick={() => handleSort('created_by')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Created By</span>
                              <span>
                                {sortField === 'created_by' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th style={{ padding: '6px', minWidth: '120px', maxWidth: '150px', whiteSpace: 'nowrap' }}>Supervisor Approval</th>
                          <th style={{ padding: '6px', minWidth: '100px', maxWidth: '130px', whiteSpace: 'nowrap' }}>HR Approval</th>
                          <th style={{ padding: '6px', width: '100px', whiteSpace: 'nowrap' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="text-center text-muted py-4">
                              {tableSearch ? 'No requests found matching your search' : 'No leave requests available'}
                            </td>
                          </tr>
                        ) : (
                          filteredData.map((item, index) => (
                            <tr 
                              key={item.id || index}
                              style={{ height: '35px', cursor: 'pointer' }}
                              className="table-row-hover"
                            >
                              <td className="text-muted fw-bold" style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                {((pagination.current_page - 1) * (pagination.per_page || DEFAULT_PER_PAGE)) + index + 1}
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-truncate d-block" style={{ maxWidth: '150px' }} title={item?.leave_type?.name}>
                                  {item?.leave_type?.name || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                <small className="text-muted">{item?.request_date || "N/A"}</small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap', textAlign: 'center' }}>
                                <small>{item?.total_days || "N/A"}</small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-truncate d-block" style={{ maxWidth: '200px' }} title={item?.leave_reason}>
                                  {item?.leave_reason || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-muted text-truncate d-block" style={{ maxWidth: '150px' }} title={item?.created_by?.name}>
                                  {item?.created_by?.name || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small><b>{getSupervisorApprovalStatus(item)}</b></small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small><b>{getHrApprovalStatus(item)}</b></small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                <button
                                  className="badge btn-success btn-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (!item?.id) {
                                      cogoToast.error("Leave request id is missing", {});
                                      return;
                                    }
                                    window.open(
                                      `/hrm/leave/print?id=${encodeURIComponent(item.id)}`,
                                      "_blank",
                                      "noopener,noreferrer"
                                    );
                                  }}
                                  style={{ fontSize: '0.75rem', padding: '4px 8px' }}
                                >
                                  <FaPrint style={{ color: "white", cursor: "pointer", fontSize: '0.7rem' }} /> Print
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {pagination.last_page > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-4" style={{ width: '95%', margin: '0 auto' }}>
                      <div className="text-muted">
                        <small>
                          Showing page {pagination.current_page} of {pagination.last_page} ({pagination.per_page} per page, {pagination.total} total)
                        </small>
                      </div>
                      
                      <nav aria-label="Leave requests pagination">
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item ${pagination.current_page === 1 || is_loading ? 'disabled' : ''}`}>
                            <button 
                              className="page-link" 
                              onClick={() => handlePageChange(pagination.current_page - 1)}
                              disabled={pagination.current_page === 1 || is_loading}
                            >
                              <span aria-hidden="true">&laquo;</span>
                            </button>
                          </li>

                          <li className="page-item active">
                            <span className="page-link">
                              {pagination.current_page} / {pagination.last_page}
                            </span>
                          </li>

                          <li className={`page-item ${(!pagination.has_more_pages && pagination.current_page >= pagination.last_page) || is_loading ? 'disabled' : ''}`}>
                            <button 
                              className="page-link" 
                              onClick={() => handlePageChange(pagination.current_page + 1)}
                              disabled={(!pagination.has_more_pages && pagination.current_page >= pagination.last_page) || is_loading}
                            >
                              <span aria-hidden="true">&raquo;</span>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
         
       
    </div>
  );
};

export default ListLeaveRequests;
